// Category rail: a native horizontal scroller with arrow affordances.
//
// The track scrolls on its own -- trackpad, touch, and keyboard all work with no
// JavaScript at all. This only adds the arrows, hides them when there is nothing
// to scroll to, and keeps them in step with however the visitor actually scrolled.
class ApsRail extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-aps-rail-track]');
    this.prev = this.querySelector('.fc-prev');
    this.next = this.querySelector('.fc-next');
    if (!this.track || !this.prev || !this.next) return;

    this.perPage = Number(this.dataset.perPage || 3);
    this.hideInactive = this.dataset.hideInactive === 'true';
    this.update = this.update.bind(this);

    this.prev.addEventListener('click', () => this.scrollBy(-1));
    this.next.addEventListener('click', () => this.scrollBy(1));
    this.track.addEventListener('scroll', this.update, { passive: true });

    // The rail's column width is a percentage of its own width, so the step
    // changes with the viewport. Recompute rather than caching a number.
    this.observer = new ResizeObserver(this.update);
    this.observer.observe(this.track);
    this.update();
  }

  disconnectedCallback() { this.observer?.disconnect(); }

  step() {
    const item = this.track.querySelector('.fc-item');
    if (!item) return this.track.clientWidth;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    return (item.getBoundingClientRect().width + gap) * this.perPage;
  }

  scrollBy(direction) {
    this.track.scrollBy({ left: this.step() * direction, behavior: 'smooth' });
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    // 1px of slack: scrollWidth and clientWidth are rounded independently, so an
    // unscrollable track can report a 0.5px overflow and leave a dead arrow.
    const scrollable = scrollWidth - clientWidth > 1;
    const atStart = scrollLeft <= 1;
    const atEnd = scrollLeft >= scrollWidth - clientWidth - 1;

    if (this.hideInactive) {
      this.prev.hidden = !scrollable || atStart;
      this.next.hidden = !scrollable || atEnd;
    } else {
      // The design keeps both arrows visible. Mark the dead one rather than
      // removing it, so it is not a silent no-op for anyone using a keyboard.
      this.prev.hidden = false;
      this.next.hidden = false;
      this.prev.disabled = !scrollable || atStart;
      this.next.disabled = !scrollable || atEnd;
    }
  }
}
customElements.define('aps-rail', ApsRail);
